import { MdCancel } from 'react-icons/md';
import { AiOutlineClose } from 'react-icons/ai';
import { IoWarningOutline } from 'react-icons/io5';
import ModalPortal from '../../../components/lib/modalPortal';
import { formatCurrency } from '../../../utils/CurrencyUtils';

export const ConfirmCancelAnticipationModal = ({ anticipation, isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <ModalPortal>
            <div className="fixed inset-0 bg-black/60 z-[60] flex items-center justify-center p-4">
                <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md animate-in zoom-in duration-200">

                    {/* Header */}
                    <div className="flex justify-between items-center mb-5">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-red-100 rounded-lg">
                                <MdCancel className="text-red-500" size={22} />
                            </div>
                            <h3 className="text-lg font-bold text-gray-800">Cancelar Antecipação</h3>
                        </div>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 transition-colors"
                        >
                            <AiOutlineClose size={20} />
                        </button>
                    </div>

                    {/* Body */}
                    <p className="text-sm text-gray-600 mb-3">
                        Tem certeza que deseja cancelar esta antecipação?
                    </p>

                    {anticipation?.requestedValue != null && (
                        <div className="flex items-start gap-2 bg-red-50 border border-red-100 rounded-lg px-3 py-2.5 mb-3">
                            <IoWarningOutline className="text-red-500 mt-0.5 shrink-0" size={16} />
                            <p className="text-xs text-red-600 font-medium">
                                A antecipação de{' '}
                                <span className="font-bold">{formatCurrency(anticipation.requestedValue)}</span>
                                {' '}será cancelada e o valor não será creditado.
                            </p>
                        </div>
                    )}

                    <p className="text-xs text-gray-400">Esta ação não pode ser desfeita.</p>

                    {/* Actions */}
                    <div className="flex gap-3 mt-5">
                        <button
                            onClick={onClose}
                            className="flex-1 py-3 bg-gray-100 hover:bg-gray-200 rounded-lg font-bold text-gray-700 transition-colors text-sm"
                        >
                            Voltar
                        </button>
                        <button
                            onClick={onConfirm}
                            className="flex-1 bg-red-500 hover:bg-red-600 active:bg-red-700 text-white font-bold py-3 rounded-lg flex justify-center items-center gap-2 transition-colors text-sm"
                        >
                            <MdCancel size={16} />
                            Sim, cancelar
                        </button>
                    </div>
                </div>
            </div>
        </ModalPortal>
    );
};
